import loadableWithRetry from '../common/loadableWithRetry'

const OrderList = loadableWithRetry(() => import('./OrderList'))

export default OrderList;
